// 房卡管理
import React, { useImperativeHandle, useRef, useState } from 'react';

import CardManage from '@/components/Cards';

interface IProps {
  innerRef;
}

export default (props: IProps) => {
  const [orderInfo, setOrderInfo] = useState(null);
  const handler = useRef(() => {});
  useImperativeHandle(
    props.innerRef,
    () => ({
      showModal: (order, callback) => {
        handler.current = callback;
        setOrderInfo(order);
      },
    }),
    [],
  );
  if (orderInfo === null) return null;

  const handleCallback = () => {
    const callback = handler.current;
    setOrderInfo(null);
    if (typeof callback === 'function') {
      callback();
    }
  };

  return (
    <CardManage
      cardsDrawerVisible
      recNo={orderInfo.recNo}
      roomId={orderInfo.roomId}
      checkInTime={orderInfo.expectedArrivalTime}
      checkOutTime={orderInfo.expectedDepartureTime}
      closeCallBack={handleCallback}
    />
  );
};
